<template>
  <div class="houseList">
    <bv-top></bv-top>
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" v-if="!isApply&&this.ghyt==='10'&&this.fwxz==='1'">
      中心城区补贴标准：新建住宅房屋面积100平以下1.5万、100-150平2万、150平以上2.5万。旗县区补贴标准按属地政策执行。
    </van-notice-bar>
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" v-if="!isApply&&this.ghyt==='10'&&this.fwxz==='2'">
      补贴标准：存量房住宅进行交易的，实行契税先征后补，按照100%全额财政补贴。
    </van-notice-bar>
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" v-if="!isApply&&this.ghyt==='123'">
      补贴标准：中心城区购买符合条件的新建、存量商业类房屋实行契税先缴后补，按照50%补贴。
    </van-notice-bar>
<!--    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" v-if="isApply">-->
<!--      补贴款将直接划转到您预留的银行账户，请注意查收。-->
<!--    </van-notice-bar>-->
    <div class="box" v-if="isApply">
      <span class="text" v-if="item.isRemit">
        补贴已发放，请及时查收！
      </span>
<!--      <span class="text" v-else-if="item.applyStatus==='2'">-->
<!--        申请驳回！-->
<!--      </span>-->
      <span class="text" v-else-if="item.applyStatus==='1'">
        已申请
      </span>
      <span class="text" v-else>
        完成申请！
      </span>
    </div>
    <van-card :key="item.htId">
      <div class="title" slot="title">
        <div class="titleContent">合同编号：{{item.htbh}}</div>
      </div>
      <div slot="desc">
        <van-cell-group>
          <van-cell title="购房人" :value="item.gfrmc"/>
          <van-cell title="房屋坐落" :value="item.fwzl"/>
          <van-cell title="房屋面积" :value="item.jzmj+'㎡'"/>
          <van-cell title="不动产权证号" :value="item.bdcqzh"/>
          <van-cell title="补贴金额" :value="'¥'+item.btje" v-if="qsFlag===1"/>
          <van-cell title="补贴账户" :value="item.btzh"/>
        </van-cell-group>
      </div>
    </van-card >
    <div slot="desc" v-if="qsFlag==='1'">
      <van-cell title="填报信息" size="large"/>
      <van-cell-group>
        <van-cell title="开户人" :value="item.gfrmc"/>
        <van-cell title="预留手机号" :value="item.sjhm"/>
      </van-cell-group>
    </div>
    <div slot="desc" v-if="qsFlag==='2'">
    <van-cell-group>
      <van-cell title="开户人" :value="item.gfrmc"/>
      <van-cell title="预留手机号" :value="item.sjhm"/>
<!--      <van-cell title="契税金额" :value="'¥'+item.qsje"/>-->
<!--      <van-cell v-if="this.ghyt==='10'"  name="btje" title="补贴金额（契税100%）" :value="'¥'+item.btje"/>-->
<!--      <van-cell v-if="this.ghyt==='123'" name="btje2" title="补贴金额（契税50%）" :value="'¥'+item.btje"/>-->
<!--      <div style="display:inline" v-if="this.showPicture">-->
<!--        <div class="uploadDiv" id="div1" >契税图片</div>-->
<!--        <div id="div2" style="float:left;">-->
<!--          <div class="image-uploader">-->
<!--            <van-image v-for="(ele,index) in this.logFiles" :key="index"-->
<!--                       style="width: 100px; height: 100px"-->
<!--                       :src="$APP_FILE +'file/'+ele.path"-->
<!--                       @click="readFile($APP_FILE +'file/'+ele.path)"-->
<!--            >-->
<!--            </van-image>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </van-cell-group>
    </div>

  </div>
</template>

<script>
  import Top from '@/views/components/Top'
  import {
    selectApplyHtDetail
  } from '@/api/houseResource/fair'
  import '@/styles/maintainFund.scss'
  import {NoticeBar} from "vant";
  import { mapGetters } from "vuex";
  import {isMobile} from "vant/lib/utils/validate/mobile";

  export default {
    name: "taxSubsidiesApplyDetails",
    props:{
      imglist:Array,
    },
    data() {
      return {
        rightImg: require('@/assets/listRight.png'),
        item: {},
        isApply: false,
        htItem: {
          btje:0.00
        },
        gfrList: [],
        showPicker: false,
        isShow:false,
        newBankCard:"",
        pattern:/^\d{16,19}$/,
        list: [],
        isShowLoading: false,
        fileList:[],
        fileList2:[],
        logFiles:[],
        showPicture:false,
        qsFlag:0,
        ghty:"0",
        fwxz:"0",
        showImg:false,
        icons:[],
        ghyt:"0"
      }
    },
    components: {
      BvTop: Top,
      VanNoticeBar: NoticeBar,
      ...mapGetters([
        "HOST"
      ]),
    },
    mounted() {
      this.showLoading();
      let htId = this.$route.query.htId;
      this.fwxz = this.$route.query.fwxz;
      this.ghyt = this.$route.query.ghyt;
      this.qsFlag = this.fwxz
      let data = {
        htId:htId,
        fwxz:this.fwxz,
        ghyt:this.ghyt
      }
      selectApplyHtDetail(data).then(res => {
        this.item = res.data;
        this.isApply = this.item.isApply;
        this.gfrList = this.item.gfrList;
        this.logFiles = this.item.logFiles;
        this.showPicture = true;

        this.$toast.clear();
      });
    },
    methods: {
      validateMobile(value) {
        return isMobile(value);
      },
      //全屏加载提示
      showLoading() {
        this.$toast.loading({
          // 持续展示 toast
          duration: 0,
          mask: true,
          message: '加载中...'
        });
      },
      onConfirm(value) {
        this.htItem.text = value.text;
        this.htItem.gfrmc = value.gfrmc;
        this.htItem.zjhm = value.zjhm;
        this.showPicker = false;
      },

      // getSubsidy(amount){
      //   if(amount===null){
      //     this.htItem.btje = 0;
      //   }
      //   this.htItem.btje = (amount/2).toString().substr(0,(amount/2).toString().indexOf(".")+3);
      // },
      // getPreviewImgList(index) {
      //   let arr = [];
      //   for (let i = 0; i < this.logFiles.length; i++) {
      //     arr.push(this.logFiles[i + index].path);
      //     if (i + index >= this.logFiles.length - 1) { // 为了取后边小值（采用绝对值）
      //       index = 0 - (i + 1);
      //     }
      //   }
      //   return arr;
      // },

      // previewImage(url, urlKey) {
      //   ImagePreview({
      //     // 真实数据
      //     images: this.list,
      //     showIndex: true,
      //     loop: true,
      //     startPosition: urlKey
      //   });
      // },

      beforeRead(){
        this.clear = true
      },
      // afterRead(event){
      //   // 当设置 mutiple 为 true 时, file 为数组格式，否则为对象格式
      //   //let lists = [].concat(event.file)
      //   this.fileList = this.fileList.concat(event.file)
      // },
      // // 删除图片
      // deletePic(event) {
      //   this.fileList.splice(event.index, 1)
      //   this.index--
      // },
      // //删除图片
      // onDelImage(index) {
      //   this.list.splice(index, 1);
      // },
      // readFile(path){//预览
      //     ImagePreview({images:[path],closeable:true});
      // },
    }
  }
</script>

<style lang="scss" scoped>
  .box {
    position: absolute;
    font-weight: bold;
    top: 45%;
    left: 46%;
    margin: -20px 0 0 -55px;
    font-size: 35px;
    color: red;
    border: 4px solid red;
    border-radius: 10px;
    z-index: 2000;
    background-color: white;
  }

  .text {
    padding: 10px;
  }
  .uploadDiv {
    float:left;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: border-box;
    padding: 10px 16px;
    overflow: hidden;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
    color: #646566;
  }
</style>
